module.exports = __webpack_public_path__ + "img/unblock_notification_firefox_1.96425988.png";